import { combineReducers, createFeature, createReducer, on } from '@ngrx/store';
import { createAsyncReducer } from '@hglobal/common';

import { supportFeatureKey, SupportState } from './support.state';
import { SupportActions } from './support.actions';
import { GetCategoriesRes } from '../models';

const categoriesReducer = createReducer<GetCategoriesRes>(
  { itemsCount: 0, categories: [] },
  on(SupportActions.getCategoriesReq.succeededAction,
    (state, action): GetCategoriesRes => action.payload),
);

const categoryIdReducer = createReducer<number>(
  null,
  on(SupportActions.categoryId, (state, action): number => action.categoryId),
);

const tipTypeReducer = createReducer<string>(
  null,
  on(SupportActions.tipType, (state, action): string => action.tipType),
);

export const supportFeature = createFeature({
  name: supportFeatureKey,
  reducer: combineReducers<SupportState>({
    categories: categoriesReducer,
    categoryId: categoryIdReducer,
    tipType: tipTypeReducer,
    getCategoriesAction: createAsyncReducer(SupportActions.getCategoriesReq),
    getTipsAction: createAsyncReducer(SupportActions.getTipsReq),
    sendMessageAction: createAsyncReducer(SupportActions.sendMessageReq),
  }),
});
